module.exports = __webpack_public_path__ + "static/media/pink_animal_reptiles.5bff3a46.webp";